// solution-wrapper.module.ts
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EXTERNAL_PLATFORM_ROUTES } from '@pics-core/dynamic'; // already exposed token
import { PageCustomComponent } from '@app/pages/page-custom.component';
import { EXTERNAL_COMPONENTS } from '@pics-core/common-utils';
import { UserAdditionalFieldsComponent } from '@app/pages/rbac/users/user-additional-fields/user-additional.fields.component';
import { AdditionalRoleFieldsComponent } from '@app/pages/rbac/groups-roles/roles/role-additional-fields/role-additional-fields.component';
import { CaseFlowTimelineComponent } from '@app/my-application/case-flow-timeline/case-flow-timeline.component';
import { ComplaintReviewComponent } from '@app/app-login/complaint-form/complaint-review/complaint-review.component';
import { ComplaintFlowTimelineComponent } from '@app/app-login/complaint-form/complaint-flow-timeline/complaint-flow-timeline.component';
import { DynamicHeaderButtonComponent } from './dynamic-header-button/dynamic-header-button.component';
import { SurrenderApplicationComponent } from '@app/surrender/surrender-application/surrender-application.component';
import { SurrenderTimelineComponent } from '@app/surrender/surrender-timeline/surrender-timeline.component';

export const solutionRoutes = [
    //sample paths
    {
        path: 'youth-photo/:pageID',
        loadChildren: () => import('../../../pages/email-template/email-template.module').then(m => m.EmailTemplateModule),
    },
    {
        path: 'youth-photo',
        component: PageCustomComponent
    },
    {
        path: 'reg-form/:pageID',
        loadChildren: () => import('../../../registration/registration.module').then(m => m.RegistrationModule)
    },
     {
        path: 'fee-and-preview/:pageID',
        loadChildren: () => import('../../../my-application/my-application.module').then(m => m.MyApplicationsModule)
    },
    {
        path: 'time-line/:pageID',
        loadChildren: () => import('../../../timeline/timeline.module').then(m =>m.TimeLineModule)
    },
    {
        path: 'fee-payment/:pageID',
        loadChildren: () => import('../../../payment/Payment.module').then(m =>m.PaymentModule)
    },
     {
                path: 'case-flow-timeline/:pageID',
                component: CaseFlowTimelineComponent
            },
             {
        path: 'license-builder/:pageID',
        loadChildren: () => import('../../../decision-role-page/decision-role-page.module').then(m =>m.DecisionRolePageModule)
    },
    {
        path: 'complaint-review/:pageID',
        component: ComplaintReviewComponent
    },
    {
        path: 'complaint-timeline/:pageID',
        component: ComplaintFlowTimelineComponent
    },
    {
        path: 'surrender-application/:pageID',
        component : SurrenderApplicationComponent
    },
    {
        path: 'surrender-timeline/:pageID',
        component : SurrenderTimelineComponent
    }
];

// External components that can be used in platform dialogs
export const solutionComponents = [
    {
        key: 'user-additional-fields',
        component: UserAdditionalFieldsComponent
    },
    {
        key: 'role-additional-fields',
        component: AdditionalRoleFieldsComponent
    },
    {
        key: 'dynamic-header-button',
        component: DynamicHeaderButtonComponent
    },
    // Add more solution components here as needed
];
@NgModule({
    declarations: [
        PageCustomComponent
    ],
    providers: [
        {
            provide: EXTERNAL_PLATFORM_ROUTES, 
            useValue: solutionRoutes
        },
        {
            provide: EXTERNAL_COMPONENTS,
            useValue: solutionComponents
        }
    ],
    exports: [PageCustomComponent]
})
export class SolutionWrapperModule { }